export default "__VITE_ASSET__DPp1AvPk__";